




import { Component, Vue } from "vue-property-decorator";
@Component({})
export default class NencWellbeingHub extends Vue {
  public static navButtonClasses: string[] = ["nenc-wellbeing-hub"];
  public static navButtonLabel: () => string = () => "Find more support at the NENC Wellbeing Hub";
}
